import { createContext } from 'react';

const MovieContext = createContext(null);

export default MovieContext;